import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useNotesServiceGetV1IndividualsByIndividualIdNotesByNoteId } from '../client/queries'

export const useNote = (individualId?: string, noteId?: string) => {
  const token = useFirebaseToken()

  return useNotesServiceGetV1IndividualsByIndividualIdNotesByNoteId(
    { individualId: individualId!, noteId: noteId! },
    undefined,
    {
      enabled: !!token && !!individualId && !!noteId,
    },
  )
}
